@if (editable) {
  <parkour-checkbox
    (checkboxChange)="handleCheckboxChange($event)"
    [checked]="actie.voltooid"
    class="flex"
  >
    {{ actie.naam }}
  </parkour-checkbox>
} @else {
  <div class="flex">
    <div class="w-6 mr-2">
      @if (actie.voltooid) {
        <parkour-icon class="flex items-center text-positive" name="check" />
      }
    </div>
    <p>{{ actie.naam }}</p>
  </div>
}
